// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__fX2-y"};